import { runInInjectionContext, Injector } from '@angular/core';
import { WcgTableValues } from '@shared/interfaces/wcg-table-utils.interface';
import {
  getUserTimezoneIdentifier,
  UtilsService,
} from '@shared/services/utils.service';
import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';
import { WcgTimeOnlyPipe } from '@wcg/frontend-framework';

export function buildDownloadData(
  wcgTableValues: WcgTableValues,
  injector: Injector,
): WcgTableValues {
  return runInInjectionContext(injector, () => {
    const _wcgTableUtilsService = injector.get(WcgTableUtilsService);
    const _utilsService = injector.get(UtilsService);
    const _wcgTimeOnlyPipe = injector.get(WcgTimeOnlyPipe);
    const currentTime = _wcgTimeOnlyPipe.transform(new Date());
    const timezoneName = currentTime.split(' ')[1];
    const timezone = _utilsService.getUserTimezoneOffset();
    const timezoneIdentifier = getUserTimezoneIdentifier();

    const param =
      _wcgTableUtilsService.generateTableQueryParams(wcgTableValues);
    const data = _wcgTableUtilsService.convertHttpParamsToObject(param);

    return {
      ...data,
      timezone,
      timezone_identifier: timezoneIdentifier,
      timezone_name: timezoneName,
    };
  });
}
